import { render, staticRenderFns } from "./ProductTen.vue?vue&type=template&id=8e0ca508&"
import script from "./ProductTen.vue?vue&type=script&lang=js&"
export * from "./ProductTen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e0ca508')) {
      api.createRecord('8e0ca508', component.options)
    } else {
      api.reload('8e0ca508', component.options)
    }
    module.hot.accept("./ProductTen.vue?vue&type=template&id=8e0ca508&", function () {
      api.rerender('8e0ca508', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/products/ProductTen.vue"
export default component.exports